import _ from 'lodash';

export const walkParentPath = (node) => {
  if (node.parent == null) {
    return [node];
  }
  return _.flattenDeep([...walkParentPath(node.parent), node]);
};
